import { FC } from 'react';
import { Control, useController } from 'react-hook-form';
import styled, { useTheme } from 'styled-components';

import Text from '@/components/Text';

import { FormDataT } from './ScriptPart';

const Button = styled.button`
  display: flex;
  height: 32px;
  width: 60px;
  align-items: center;
  padding: 4px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.grayscale};
  transition: 0.15s ease-in-out border-color;
  &:hover {
    border-color: ${({ theme }) => theme.colors.lightGray};
  }
`;

const Label = styled(Text)`
  text-transform: capitalize;
  flex: 1;
  text-align: center;
  margin-left: 4px;
`;

interface Props {
  control: Control<FormDataT>;
  variation: keyof FormDataT['text'];
}

const VariationSwitchField: FC<Props> = ({ control, variation }) => {
  const {
    field: { value, onChange },
  } = useController<FormDataT, 'selectedTranslation'>({
    name: 'selectedTranslation',
    control,
  });

  const theme = useTheme();

  return (
    <Button type="button" onClick={() => onChange(variation)}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          width="24"
          height="24"
          rx="4"
          fill={
            value === variation ? theme.colors.success : theme.colors.grayscale
          }
        />
        <path
          d="M15 10.332L11 14.332L9 12.332"
          stroke={value === variation ? theme.colors.white : theme.colors.gray}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <Label as="span" $type="smallHeadline">
        {variation}
      </Label>
    </Button>
  );
};

export default VariationSwitchField;
